const legalDocuments = {
  legal_documents: "Legal Documents",
  legal_documents_title: "Legal Documents",
  document_type: "Document Type",
  project_number: "Project Number",
  document: "Document",
  supplier: "Supplier",
  supplier_name: "Supplier Name",
  filter_by_project_number: "Project Number",
  Albaran: "Delivery Note",
  "Albarán/proforma": "Delivery Note",
  "Contrato Firmado": "Signed Contract",
  "Corriente Pago": "Current Payment",
  company_id: "Company ID"
};

export default legalDocuments;
